'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = require('./common');

exports.default = (0, _common.regex)('numeric', /^[0-9]*$/);


//////////////////
// WEBPACK FOOTER
// ./~/vuelidate/lib/validators/numeric.js
// module id = 328
// module chunks = 0